import { render, staticRenderFns } from "./YoneticiDuzenle.vue?vue&type=template&id=cb634b48&scoped=true&"
import script from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
export * from "./YoneticiDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiDuzenle.vue?vue&type=style&index=0&id=cb634b48&lang=scss&scoped=true&"
import style1 from "./YoneticiDuzenle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb634b48",
  null
  
)

export default component.exports